var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21v-1a6 6 0 0 1 6-6h2a6 6 0 0 1 3.5 1.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14v7M15.5 17.5h7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveContact);
export default __webpack_public_path__ + "static/media/save-contact.c3dc7c764c4e5a2821d1cbb771220cbe.svg";
export { ForwardRef as ReactComponent };